import { createTheme } from '@mui/material/styles';
import { typographyOptions } from './typography';
import { palette } from './palette';
import { components } from './components';
import { breakpoints } from './breakpoints';
import '@mui/material/styles';
import '@mui/material';
import { TypographyStyleOptions } from '@mui/material/styles/createTypography';

declare module '@mui/material/styles' {
  interface Palette {
    customColors: {
      black: string;
    };
  }

  interface PaletteOptions {
    customColors: {
      black: string;
    };
  }
  interface TypographyVariants {
    subtitle: TypographyStyleOptions;
  }

  interface TypographyVariantsOptions {
    subtitle?: TypographyStyleOptions;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    subtitle?: true;
  }
}

let theme = createTheme({
  components,
  palette,
  breakpoints,
});
theme = createTheme({
  ...theme,
  typography: typographyOptions(theme),
});

export const globalStyles = theme;
